if (typeof (Lemo_Contextmenu) == "undefined")
{
    var Lemo_Contextmenu =
    {
        buttons: {},

        /**
         * Prida tlacitko do kontextoveho menu
         *
         * @param {string} label
         * @param {string} glyphicon
         * @param {function} callback
         */
        addButton: function(label, glyphicon, callback)
        {
            this.buttons[label] = new Object();
            this.buttons[label].label = label;
            this.buttons[label].glyphicon = glyphicon;
            this.buttons[label].callback = callback;
        },

        /**
         * Zobrazi kontextove menu
         *
         * @param e
         * @param element
         */
        build: function(e, element)
        {
            this.remove();

            var elementContainer = $('<ul id="contextmenu" class="list-unstyled"></ul>');

            if(typeof this.buttons != 'undefined') {
                $.each(this.buttons, function(i, button) {
                    var icon = '';
                    if(typeof button.glyphicon != 'undefined' && button.glyphicon != '') {
                        icon = '<i class="glyphicon glyphicon-' + button.glyphicon + '"></i> ';
                    }

                    var elementButton = $('<li class="btn btn-default">' + icon + translate(button.label) + '</li>');

                    elementButton.on('click', function() {
                        if($.isFunction(button.callback)) {
                            button.callback.apply();
                        }

                        $('#contextmenu').stop().slideUp(150, function() {
                            $('#contextmenu').remove();
                        });
                    });

                    elementContainer.append(elementButton);
                });
            }

            $('body').append(elementContainer);

            var windowWidth = $(window).outerWidth();
            var windowHeight = $(window).outerHeight();
            var windowScrollTop = $(window).scrollTop();
            var elementOffset = $(element).offset();
            var elementHeight = $(element).outerHeight();
            var elementWidth = $(element).outerWidth();
            var top = e.pageY + 10;
            var left = e.pageX - ($('#contextmenu').outerWidth() / 2);

            // Left is minimal
            if (0 > (left + $('#contextmenu').outerWidth())) {
                left = 10;
            }

            // Prava je maximalni
            if (left > (windowWidth - $('#contextmenu').outerWidth())) {
                left = windowWidth - $('#contextmenu').outerWidth() - 10;
            }

            // Spodni je vyssi nez okno
            if ((elementOffset.top + elementHeight) > (windowHeight + windowScrollTop)) {
                top = elementOffset.top - $('#contextmenu').outerHeight() - 10;
            }

            // Pridame contextmenu do radku
            // Zobrazime contextove menu
            $('#contextmenu').css('top', top + 'px');
            $('#contextmenu').css('left', left + 'px');
            $('#contextmenu').stop().slideDown(150);

            $(document).on("mousedown", function(e) {
                if (e.which == 1 && $('#contextmenu').length > 0) {
                    if (e.target.id == 'contextmenu' || $(e.target).parent().attr('id') == 'contextmenu') {
                        e.target.click;
                    } else {
                        $('#contextmenu').stop().slideUp(150, function() {
                            $('#contextmenu').remove();
                        });
                    }
                }
            });

            // Skryti menu v pripade stisku ESC
            $(document).on("keydown", function(e) {
                if (e.keyCode && e.keyCode === 27 && $('#contextmenu').length > 0) {
                    $('#contextmenu').stop().slideUp(150, function() {
                        $('#contextmenu').remove();
                    });
                }
            });

            this.buttons = {};
        },

        /**
         * Odstrani kontextove menu
         */
        remove: function()
        {
            $('#contextmenu').remove();
        }
    }
}
